// Reviews API functions
const API_BASE = process.env.REACT_APP_API_URL || '/api';

export const getReviews = async () => {
    const response = await fetch(`${API_BASE}/reviews`);
    if (!response.ok) throw new Error('Failed to fetch reviews');
    return response.json();
};

export const submitReview = async (reviewData) => {
    const response = await fetch(`${API_BASE}/reviews`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(reviewData),
    });
    if (!response.ok) throw new Error('Failed to submit review');
    return response.json();
};

export const seedReviews = async () => {
    const response = await fetch(`${API_BASE}/reviews/seed`, {
        method: 'POST',
    });
    if (!response.ok) throw new Error('Failed to seed reviews');
    return response.json();
};
